<template>
  <div class="md-example-child md-example-child-radio md-example-child-radio-2">
    <md-field title="Select Beneficiary Bank" class="radio-field">
      <md-radio-group v-model="myBank">
        <md-radio
          v-for="value in bankList"
          :key="value.bankNo"
          :name="value.bankNo"
          icon-svg
          size="lg"
          @input="handleSelectBank(value)"
        >
          <div class="custom-title">
            <img
              class="svg-icon"
              :src="getIconByCode(value.bankNo)"
              alt="bank-icon"
            >
            {{ value.bankShortName }}
          </div>
        </md-radio>
      </md-radio-group>
    </md-field>
  </div>
</template>

<script>
import { Field, Radio, RadioGroup } from 'mand-mobile'
import { getIconByCode } from '@flash/fin-logo'
import { getBankList } from '@/api/transfer'

export default {
  name: 'TransferToBank',
  components: {
    [Field.name]: Field,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup
  },
  data () {
    return {
      getIconByCode,
      myBank: '',
      bankList: []
    }
  },
  created () {
    this.getBankList()
  },
  methods: {
    // 获取银行列表
    async getBankList () {
      this.bankList = await getBankList({ whetherSign: 0 }) || []
    },

    handleSelectBank (value) {
      this.$router.push({ name: 'TransferToBankVerify', query: value })
    }
  }
}

</script>

<style lang="scss" scoped>
.radio-field {
  ::v-deep .md-field-title {
    font-size: 32px !important;
    margin: 20px 0 !important;
    color: rgb(128, 128, 128) !important;
  }

  .md-radio {
    background-color: rgb(249, 251, 252);
    padding: 40px 20px;
    margin: 0;
    border-bottom: 1px solid #eee;
  }
}

.custom-title {
  display: flex;
  align-items: center;

  .svg-icon {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    margin-right: 16px;
  }
}
</style>
